module.exports = __webpack_public_path__ + "static/img/menu6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu6.png
// module id = 560
// module chunks = 0